export default __webpack_public_path__ + "img/Intestine.71b77541.png";